export default __webpack_public_path__ + "static/media/home-restaurant-img-12.72cf153c.jpg";